import React, { Component } from 'react';
import Error from '../../../components/error/error';

// eslint-disable-next-line no-restricted-syntax -- error boundary: React has no hook for componentDidCatch / getDerivedStateFromError
class ErrorBoundary extends Component {
    state = {
        failed: false
    };

    componentDidCatch(error, errorInfo) {
        this.setState({ failed: true, error: error ?? errorInfo });
    }

    render() {
        const { children, noReport } = this.props;
        const { error } = this.state;

        return this.state.failed ? <Error showRefreshButton noReport={noReport} error={error} /> : children;
    }
}

export default ErrorBoundary;
